import { cn } from "@omni/utils/styles";
import "./amount.scss";

type AmountProps = {
    amount: number;
    className?: string;
};

const Amount = ({ amount, className }: AmountProps) => {
    if (amount < 1) {
        return null;
    }

    return <div className={cn("amount", className)}>{`${amount} x`}</div>;
};

export { Amount };
